import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats prices for billing display
 * - Adds commas for thousands separator
 * - Always shows decimals (cents) for accurate pricing
 * - Adds currency symbol ($)
 */
@Pipe({
    name: 'billingPriceFormat',
    standalone: false
})
export class BillingPriceFormatPipe implements PipeTransform {

    transform(value: number | string | null | undefined, options?: { excludeSymbol?: boolean }): string {
        if (value === null || value === undefined) {
            return '--';
        }

        let numValue: number;

        if (typeof value === 'string') {
            numValue = parseFloat(value);
        } else {
            numValue = value;
        }

        if (isNaN(numValue)) {
            return '--';
        }

        // Check if number has decimal places
        const hasDecimals = numValue % 1 !== 0;

        // Format with decimals only if needed
        const formattedNumber = numValue.toLocaleString('en-US', {
            minimumFractionDigits: hasDecimals ? 2 : 0,
            maximumFractionDigits: 2
        });

        // Add currency symbol unless excluded
        const excludeSymbol = options?.excludeSymbol ?? false;
        return excludeSymbol ? formattedNumber : `$${formattedNumber}`;
    }
}

